import BlazePose from "@/elite-lib-yt/pose-detectors/blazepose/BlazePose";

export default class EliteRep extends BlazePose {

    constructor(eliteService, options) {
        options.stickFigureLineColor = () => {
            return '#c9cbf7';
        };
        super(eliteService, options);
        this.visible = false;
        this.form = 0;
        this.direction = 0;
        this.count = 0;
        this.directionTotal = 0;
        this.total = 0;
        this.start = true;
        this.baseLine = options.baseLine;
        this.poseLandmarksCallback = options.poseLandmarksCallback;
        this.onResult = options.onResult;
        this.onVisibilityChange = options.onVisibilityChange;
        this.totalRepDeviation = options.totalRepDeviation ? options.totalRepDeviation : 30;
        this.userPoseCountList = [];
        this.accuracyScore = 0;
    }

    /* For Rep count capture all */
    async _shouldCapture() {
        return true;
    }

    initCamera(videoEl, canvasEl, instructorVideoEl, videoId, onlyBlazePose = false) {
        this.onlyBlazePose = onlyBlazePose;
        if (onlyBlazePose) {
            return this.initBlazePoseOnly(videoEl, canvasEl, instructorVideoEl, videoId, this.onPoseLandmarks);
        }
        return this.initBlazePose(videoEl, canvasEl, instructorVideoEl, videoId, this.onPoseLandmarks, 1, false);
    }

    async initRepetitionWorkout(webCamEl, drawingCanvasEl, videoPlayer, EFTech=1, videoInfo=null) {
        return this.initPoseDetection(webCamEl, drawingCanvasEl, videoPlayer, EFTech, videoInfo)
    }

    onPoseLandmarks(landmarks) {
        if (typeof this.poseLandmarksCallback === 'function') {
            this.poseLandmarksCallback(landmarks);
        }
        this.countRepetition(landmarks);
    }

    countRepetition(landmarks) {
        if (typeof this.onVisibilityChange === 'function') {
            if (this.visible !== (landmarks && landmarks.length === 33)) {
                this.onVisibilityChange((landmarks && landmarks.length === 33));
            }
        }
        this.visible = (landmarks && landmarks.length === 33);
        if (this.visible) {
            if (this.checkForm(landmarks, this.baseLine.form)) {
                this.form = 1;
            }
            if (this.form === 1 && this.start) {
                this.checkMotionCount(landmarks, this.baseLine.motion);
                // this.checkMotionTotal(landmarks, this.baseLine.motion);
            }
        }
    }

    async uploadCount() {
        let time = await this.videoPlayer.getCurrentTime();
        this.eliteService.updateRepCount(
            this.videoId,
            this.sessionId,
            Math.floor(this.count * 2),
            this.accuracyScore,
            +time
        ).then(resp => { });
    }

    getAccuracy() {
        return Math.round((this.userPoseCountList.reduce((sum, a) => sum + a, 0) / this.userPoseCountList.length) * 100);
    }

    manuallyIncrementCount() {
        this.incrementCount(this.direction, this.baseLine.motion, true);
    }

    incrementCount(direction, motion, isManualIncrement = false) {
        this.userPoseCountList.push(isManualIncrement? 0 : 1);
        this.accuracyScore = this.getAccuracy();
        const total = motion.length;
        const pmc = 1 / total;
        this.count += pmc;
        // update the direction to the next form if its a last form in the array then to the first form
        if (direction === (total - 1)) {
            this.direction = 0;
        }
        else {
            this.direction = direction + 1;
        }
        // console.log('onResult: ', typeof this.onResult);
        if (typeof this.onResult === 'function') {
            this.onResult(
                this.count,
                this.total,
                this.accuracyScore,
                this.userPoseCountList,
                isManualIncrement
            );
        }
        this.uploadCount();
    }

    checkMotionCount(landmarks, motion) {
        const total = motion.length;
        const pmc = 1 / total;
        let i = 0;
        // Loop through motion array
        for (const form of motion) {
            // If current direction matches the motion array index i.e form which we need to check in current direction
            if (this.direction === i) {
                // Check if the from is correct if its correct then update the count
                if (this.checkForm(landmarks, form)) {
                    this.incrementCount(i, motion);
                }
            }
            i += 1;
        }
    }

    checkMotionTotal(landmarks, motion) {
        const total = motion.length;
        const pmc = 1 / total;
        let i = 0;
        // Loop through motion array
        for (const form of motion) {
            // If current direction matches the motion array index i.e form which we need to check in current direction
            if (this.directionTotal === i) {
                // Check if the from is correct if its correct then update the count
                if (this.checkForm(landmarks, form, this.totalRepDeviation)) {
                    this.total += pmc;
                    // update the direction to the next form if its a last form in the array then to the first form
                    if (i === (motion.length - 1)) {
                        this.directionTotal = 0;
                    }
                    else {
                        this.directionTotal = i + 1;
                    }
                    if (typeof this.onResult === 'function') {
                        this.onResult(this.count, this.total);
                        //Only upload count for full motion rep
                        if (!(this.total % 1) && !this.onlyBlazePose) {
                            this.uploadCount();
                        }
                    }
                }
            }
            i += 1;
        }
    }

    checkForm(landmarks, form, deviation = null) {
        for (const pose of form) {
            const angle = this.getAngle(landmarks, pose.p1, pose.p2, pose.p3);
            let nd;
            let pd;
            if (deviation) {
                nd = deviation;
                pd = deviation;
            }
            else {
                nd = pose.nd;
                pd = pose.pd;
            }
            if (!this.checkAngle(angle, pose.a, nd, pd)) {
                return false;
            }
        }
        return true;
    }

    // If expecting 90 with deviation of +-10 so angle of 80 to 100 should send true
    checkAngle(angle, expectedAngle, negativeDeviation = 10, positiveDeviation = 10) {
        let a1 = expectedAngle - negativeDeviation;
        let a2 = expectedAngle + positiveDeviation;
        return angle > a1 && angle < a2;
    }

    getAngle(landmarks, p1, p2, p3) {
        try {
            const {x: x1, y: y1} = landmarks[p1];
            const {x: x2, y: y2} = landmarks[p2];
            const {x: x3, y: y3} = landmarks[p3];
            let angle = this.degrees(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y1 - y2, x1 - x2));
            if (angle < 0) {
                angle += 360;
                if (angle > 180) {
                    angle = 360 - angle;
                }
            } else if (angle > 180) {
                angle = 360 - angle;
            }
            return angle;
        } catch (e) {
            console.log(e.message);
        }
        return 0;
    }

    degrees(radians) {
        return radians * (180 / Math.PI);
    }

    // dispose() {
    //     this.videoElement.srcObject.getTracks().forEach(function(track) {
    //         //stop camera
    //         track.stop();
    //     });
    // }

    // ----------------------------------------------------------------------------- //
    // ---------------- GetInFrame Pose detection STARTS   ------------------------- //
    // ----------------------------------------------------------------------------- //
    async initPoseDetectionV2(webCamEl, drawingCanvasEl, videoPlayer, EFTech=1, videoInfo=null) {
        this.changeVideoInfo(videoInfo);
        this.webCamEl = webCamEl;
        this.drawingCanvasEl = drawingCanvasEl;
        this.videoPlayer = videoPlayer;
        if (!this.webCamEl || !this.drawingCanvasEl || !this.videoPlayer) {
            throw Error("Please pass proper references/parameters");
        }
        this.webCamCanvasCtx = this.drawingCanvasEl.getContext('2d');
        return this.startPoseDetection();
    }

    async initScoreCalculationV2() {
        await this.createNewWorkoutSession(this.EFTech, this.playingVideoId);
        let workoutType = this.options?.workoutType || 'repetition';
        if (this.sessionId) {
            if (workoutType === 'repetition')
                this.poseLandmarksCallback = this.countRepetition;
            if (this.options.pauseVideoIfUserIsAway) {
                this._checkUserMovementBP();
            }
        } else {
            throw new Error(this.getSessionMessage());
        }
    }
    // ----------------------------------------------------------------------------- //
    // ---------------- GetInFrame Pose detection ENDS     ------------------------- //
    // ----------------------------------------------------------------------------- //

}
